import { AgentFace, GroupFaceIcon, PersonFace, TokenFace } from '../../components/nucleus/faces';
import React from 'react';
import { AppFace, elementOf } from '../../components/nucleus/cells';
import ContractMark from '../../components/nucleus/ContractMark';
import StatusPill from '../../components/nucleus/StatusPill';
import { until } from '../../nucleus/format';

// The pieces Realms & Contracts draw with (parity with nucleus.oS
// SecurityPage.swift): an entity's face, a contract's mark, a row's badge.

export function appOf(p) {
    const el = elementOf({ name: p.label });
    return { id: el?.id || p.entityId, name: p.label };
}

/** The face of whoever holds a profile. */
export function EntityFace({ profile, size = 50 }) {
    if (profile.kind === 'app') return <span className="realms-face-app" style={{ width: size, height: size }}><AppFace app={appOf(profile)} size={size} /></span>;
    if (profile.kind === 'person' || profile.kind === 'member') return <PersonFace url={profile.avatar_url} size={size} />;
    if (profile.kind === 'group') return <GroupFaceIcon url={profile.avatar_url} size={size} />;
    if (profile.kind === 'token') return <TokenFace size={size} />;
    return <AgentFace size={size} />;
}

/** An exposure profile's mark: the contract, sealed with its holder's face. */
export function GrantMark({ profile, size = 50, dim }) {
    const seal = Math.round(size * 0.5);
    return <ContractMark size={size} dim={dim} seal={<EntityFace profile={profile} size={seal} />} />;
}

/** What a row of profiles warrants on its corner: paused, or expiring soon. */
export function badgeOf(profiles, now = Date.now()) {
    if (profiles.every((p) => !p.active)) return <StatusPill status="paused" of="contract" />;
    const e = profiles.map((p) => p.expires).filter(Boolean).sort((a, b) => a - b)[0];
    if (e && e.getTime() < now + 14 * 86_400_000) {
        const days = Math.floor((e.getTime() - now) / 86_400_000);
        return <StatusPill status="expiring" title={`Expires ${until(e, { now, days: true })}`}>Expires {days <= 0 ? 'today' : `${days}d`}</StatusPill>;
    }
    return undefined;
}
